var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalpayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 0H6C2.68629 0 0 2.68629 0 6V46C0 49.3137 2.68629 52 6 52H46C49.3137 52 52 49.3137 52 46V6C52 2.68629 49.3137 0 46 0Z",
    fill: "#CCD5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2917 27.6146C31.8542 28.0417 31.6042 28.6562 31.6667 29.3125C31.7604 30.4375 32.7917 31.2604 33.9167 31.2604H35.8958V32.5C35.8958 34.6562 34.1354 36.4167 31.9792 36.4167H20.0208C17.8646 36.4167 16.1042 34.6562 16.1042 32.5V25.4896C16.1042 23.3333 17.8646 21.5729 20.0208 21.5729H31.9792C34.1354 21.5729 35.8958 23.3333 35.8958 25.4896V26.9896H33.7917C33.2083 26.9896 32.6771 27.2187 32.2917 27.6146Z",
    stroke: "#4676FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1042 26.4271V21.6667C16.1042 20.4271 16.8646 19.3229 18.0208 18.8854L26.2917 15.7604C27.5833 15.2708 28.9688 16.2292 28.9688 17.6146V21.5729",
    stroke: "#4676FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9988 28.0522V30.1981C36.9988 30.7711 36.5404 31.2398 35.9571 31.2606H33.9154C32.7904 31.2606 31.7592 30.4377 31.6654 29.3127C31.6029 28.6564 31.8529 28.0418 32.2904 27.6148C32.6758 27.2189 33.2071 26.9898 33.7904 26.9898H35.9571C36.5404 27.0106 36.9988 27.4793 36.9988 28.0522Z",
    stroke: "#4676FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7917 26H28.0833",
    stroke: "#4676FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalpayout);
export default __webpack_public_path__ + "static/media/totalpayout.6fc6dc9d45b0d71d215b2c0cc9b4b007.svg";
export { ForwardRef as ReactComponent };